module.exports = __webpack_public_path__ + "static/media/bkg03d.0cd9f8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg03d.jpg
// module id = 467
// module chunks = 0